// extracted by mini-css-extract-plugin
module.exports = {"card-order":"_2RwJH","card-lastorder-item":"_1Ml4r","status":"_2d_IW","date":"_2F9N9","productNumber":"_3quie","price":"_1Chrk"};